__turbopack_context__.v({
  "arrowIcon": "CourseButton-module__QwYLka__arrowIcon",
  "buttonSpacer": "CourseButton-module__QwYLka__buttonSpacer",
  "checkIconWrapper": "CourseButton-module__QwYLka__checkIconWrapper",
  "ctaSection": "CourseButton-module__QwYLka__ctaSection",
  "ctaSectionDisabled": "CourseButton-module__QwYLka__ctaSectionDisabled",
  "selectButton": "CourseButton-module__QwYLka__selectButton",
});
